export default "static/media/trustiin.2201996.svg"